import { useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

import { BonusMappedType } from "../../../types/Bonus";

import Progressbar from "../../atoms/Progressbar";
import useFormatBonusBalance from "../../../hooks/useFormatBonusBalance";
import BonusIcon from "../../../assets/icons/bonus.svg?react";
import useTranslate from "../../../hooks/useTranslate";

import "./BonusWidget.sass";

import url from "../../../url";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import Timer from "../../atoms/Timer";

type BonusWidgetProps = {
  bonus: BonusMappedType;
};

const BonusWidget = (props: BonusWidgetProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { reward, progress, expireDate } = props.bonus;
  const formatBonus = useFormatBonusBalance();
  const t = useTranslate();
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();

  const handleDeposit = () => {
    navigate(makeLangUrl(url.routes.profile.bonus()));
  };

  return (
    <div className="BonusWidget" onClick={() => !isDesktop && handleDeposit()}>
      <div className="BonusWidget-header">
        <span className="BonusWidget-header__title">
          {t("bonus.info.header")}
        </span>
        <span className="BonusWidget-header__info" onClick={handleDeposit}>
          info
        </span>
      </div>
      <div className="BonusWidget-container">
        <div className="BonusWidget-container-reward">
          <span className="BonusWidget-container-reward__title">
            {t("profile.bonus.title")}
          </span>
          <div className="BonusWidget-container-reward-value">
            <BonusIcon className="BonusWidget-container-reward-value__img" />
            <span className="BonusWidget-container-reward-value__text">
              {reward || reward === 0 ? formatBonus(reward) : ""}
            </span>
          </div>
        </div>
        <div className="BonusWidget-container__timer">
          <Timer finishDate={expireDate} isBonus />
        </div>
        <div className="BonusWidget-container__progress">
          <Progressbar width={progress} type="widget" />
        </div>
      </div>
    </div>
  );
};

export default BonusWidget;
